export const DEFAULT_ALT_IMAGE = 'Constellium image'
export const DEFAULT_ALT_VIDEO = 'Constellium video'
